export const isOffice = () => (window as {Office?: {}}).Office !== undefined;
